import { tryGetHostApi } from "./externalApi";
export async function getFeedProviderHostApi() {
    return (await tryGetHostApi("FeedProvider", 2, 2));
}
